const sportsData = [
    {
        id: 1,
        name: "بدنسازی",
        nameInLatin: "Fitness",
        img: "/images/weight.png",
        color: "var(--pink)",
        subset: "/bodyBuildingCoaching"
    },
    {
        id: 2,
        name: "پیلاتس",
        nameInLatin: "Pilates",
        img: "/images/pilates.svg",
        color: "var(--orange)",
        subset: ""
    },
    {
        id: 3,
        name: "یوگا",
        nameInLatin: "Yoga",
        img: "/images/yoga.svg",
        color: "var(--dark-green)",
        subset: ""
    }
]

export default sportsData